export default __webpack_public_path__ + "static/media/svg-4.d26f7a27.svg";